import { useEffect, useContext, useState, useRef } from 'react';

import styles from './TopicComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";

import TopicDetailsComponent from "./TopicDetailsComponent";
import ShowTopicCheckbox from "./ShowTopicCheckbox";

const TopicComponent = ({ topic, index, setSelectedTopic, selectedTopic, topicsLength }) => {

    const { currentTopic, currentParticipant, socketRef, currentConference } = useContext(GlobalContext);

    const selectedRef = useRef();

    const [topicNumber, setTopicNumber] = useState("01");

    useEffect(() => {
        selectedRef.current = false;
    }, [])

    useEffect(() => {
        if (index < 10) {
            setTopicNumber("0" + index);
        } else {
            setTopicNumber("" + index);
        }
    }, [index])

    const GoToNextTopic = () => {
        socketRef.current.emit("GO_TO_NEXT_TOPIC", currentConference._id);
    }

    const HideTopic = () => {
        socketRef.current.emit("GO_TO_TOPIC", currentConference._id, null);
    }

    const ShowTopic = () => {
        socketRef.current.emit("GO_TO_TOPIC", currentConference._id, topic._id);
    }

    const openDiscussion = () => {
        socketRef.current.emit("OPEN_DISCUSSION", currentConference._id);
        HideTopic()
    }


    return (
        <div className={styles.component} >
            <div onClick={() => setSelectedTopic((topic._id === selectedTopic) ? null : topic._id)}
                style={{
                    cursor: "pointer", borderRadius: topic._id !== selectedTopic ? "10px" : "10px 10px 0px 0px",
                    display: "flex", padding: "0px", margin: "0px 0px", color: "white", width: "900px", height: "100%",
                    backgroundColor: (topic._id === currentTopic?._id ? "#292148" : "#161032"),
                    fontSize: "30px", overflow: "hidden"
                }}>
                {currentTopic?._id === topic._id &&
                    <>

                        <div style={{
                            height: "auto", padding: "0px 20px", color: "#33FFC8", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#423467",
                            font: "normal normal bold 74px/126px 'Helvetica Condensed'"
                        }}>
                            {topicNumber}
                        </div>
                        <div style={{
                            height: "auto", width: "calc(85% - 20px)", marginLeft: "20px", position: "relative", display: "flex", flexDirection: "column", justifyContent: "center",
                            padding: "40px 10px"
                        }}>
                            {currentConference.type === "Presentation" && <ShowTopicCheckbox onClick={() => HideTopic()} />}
                            <div style={{ font: "normal normal 600 70px/74px 'Bio Sans'", color: "#33FFC8", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                                {topic.name}
                            </div>

                            {currentConference.type !== "Presentation" && <>
                                <div style={{ font: "normal normal normal 32px/42px 'Bio Sans'", color: "#EEEEEE", position: "relative", maxWidth: "740px" }}>
                                    <i className="fa-thin fa-microphone-stand" style={{ font: "normal normal 300 28px/35px", margin: "10px 20px 0px 0px" }}></i>
                                    {topic?.moderator.name}
                                </div>
                                {currentTopic?.moderator._id === currentParticipant?._id && topicsLength !== index && <div style={{
                                    position: "absolute", right: "10px", bottom: "10px", backgroundColor: "#77EDDC",
                                    color: "black", padding: "10px 20px", font: "normal normal 600 24px/33px Bio Sans", borderRadius: "8px"
                                }}
                                    onClick={() => GoToNextTopic()}>NEXT TOPIC</div>}
                                {currentTopic?.moderator._id === currentParticipant?._id && topicsLength === index && <div style={{
                                    position: "absolute", right: "10px", bottom: "10px", backgroundColor: "#77EDDC",
                                    color: "black", padding: "10px 20px", font: "normal normal 600 24px/33px Bio Sans", borderRadius: "8px"
                                }}
                                    onClick={openDiscussion}>OPEN DISCUSSION</div>}
                            </>
                            }


                        </div>
                    </>
                }
                {currentTopic?._id !== topic._id &&
                    <>
                        <div style={{
                            height: "auto", fontSize: "74px", fontWeight: "bold", margin: "0px 20px", color: "#726FA8", display: "flex", justifyContent: "center",
                            alignItems: "center", font: "normal normal bold 74px/126px 'Helvetica Condensed'"
                        }}>{topicNumber}</div>
                        <div style={{
                            height: "auto", minHeight: "130px", width: "calc(100% - 20px)", marginLeft: "20px", position: "relative", display: "flex", flexDirection: "column",
                            justifyContent: "center", padding: "20px 10px"
                        }}>
                            {currentConference.type === "Presentation" && <ShowTopicCheckbox isOn={true} onClick={() => ShowTopic()} />}
                            <div style={{
                                font: "normal normal 600 50px/44px Bio Sans", color: "#726FA8", margin: "0px 0px 0px 0px", maxWidth: "85%", overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}>{topic.name}</div>

                            {currentConference.type === "Conference" &&
                                <div style={{ font: "normal normal normal 32px/38px Bio Sans'", color: "#726FA8", position: "relative", marginTop: 10 }}>

                                    <i className="fa-thin fa-microphone-stand" style={{ font: "normal normal 300 28px/35px", marginRight: 10 }}></i>
                                    {topic?.moderator.name}
                                </div>
                            }
                        </div>
                    </>
                }
            </div>

            {((currentConference.type === 'Meeting' || currentConference.moderatedBy === currentParticipant?._id || topic.moderator._id === currentParticipant?._id
                || currentConference.discussionOpened) && (currentTopic?._id === topic._id || selectedTopic === topic._id)) &&
                <TopicDetailsComponent key={topic._id} topic={topic}></TopicDetailsComponent>
            }
        </div>
    );
}

export default TopicComponent;